module.exports = __webpack_public_path__ + "static/media/ceremony.9e91cfce.png";